function ShareWhatsapp(
  receipt_no,
  name,
  address,
  mobile,
  amount,
  amount_in_words,
  receipt_date,
  title,
  tamiltitle
) {
  const festivalLine = title.includes('KUMBAABISHEGAM') ? 'Kumbaabishegam / கும்பாபிஷேகம்' : 'Sivanrathiri / சிவன்ராத்திரி';

  const message = `உ
*ஸ்ரீ மஹா கணபதி அனுக்ரஹம்*
*ஸ்ரீ சிவகாமியம்மன் சமேத ஸ்ரீ ஆலடீஸ்வரன் துணை*

ஸ்ரீ ஆலடி ஈஸ்வரர் சமேத சிவகாமியம்மாள் திருக்கோவில்
ஈஞ்சார், சிவகாசி மேற்கு, விருதுநகர் மாவட்டம் - 626124

------------------------------------------------------
*${title} RECEIPT ${new Date().getFullYear()} / ${tamiltitle} ரசீது ${new Date().getFullYear()}*
------------------------------------------------------

*Receipt no* : ${receipt_no}
*Name* : ${name}
*Address* : ${address}
*Mobile* : ${mobile}
*Amount* : ₹${amount} (${amount_in_words})
*Date* : ${receipt_date}
*Festival* : ${festivalLine}`;

  const encodedMessage = encodeURIComponent(message);
  window.open(
    `https://api.whatsapp.com/send?phone=+91${mobile}&text=${encodedMessage}`,
    "_blank"
  );
}

export default ShareWhatsapp;
